import { useIsMobile } from '@hooks';
import Modal from '@components/Modal';
import Collaborator from './Collaborator';
import s from '../UserWorkflowDetail.module.scss';

type OnChangeCollaborator = Parameters<Parameters<typeof Collaborator>[0]['onChange']>[0];

type Props = {
  collaborators: Parameters<typeof Collaborator>[0]['collaborator'][];
  userWorkflow: { id: string };
  onClose: () => void;
  onChange: (collaborator: OnChangeCollaborator) => void;
  myCollaborator: {
    id: string;
    canInviteCollaborators: boolean;
  } | null;
};

const AddUserWorkflowCollaboratorModal: React.FC<Props> = ({ collaborators, userWorkflow, onClose, onChange, myCollaborator }) => {
  const isMobile = useIsMobile();

  const handleChangeCollaborator = (updatedCollaborator: OnChangeCollaborator): void => {
    onChange(updatedCollaborator);
  };

  const sellersCollaborators = collaborators?.filter(collaborator => collaborator.source === 'creator' || collaborator.source === 'creator-team-member') ?? [];
  const customersCollaborators = collaborators?.filter(collaborator => collaborator.source === 'customer' || collaborator.source === 'organization-member') ?? [];

  const otherCollaborators = collaborators?.filter(
    collaborator =>
      collaborator.source !== 'creator'
        && collaborator.source !== 'creator-team-member'
        && collaborator.source !== 'customer'
        && collaborator.source !== 'organization-member',
  ) ?? [];

  return (
    <Modal hideBottomInset isPinnedToBottom={isMobile} title={'Collaborators'} onClose={onClose} hasCloseOnActions={false} hasForm={false}>
      <div className={s['collaborator-list-wrapper']}>
        {sellersCollaborators.length > 0 && (
          <section>
            {sellersCollaborators.map(collaborator => (
              <Collaborator
                key={collaborator.id}
                collaborator={collaborator}
                onChange={handleChangeCollaborator}
                userWorkflow={userWorkflow}
                isAllowedToChange={myCollaborator?.canInviteCollaborators ?? false}
              />
            ))}
          </section>
        )}
        {customersCollaborators.length > 0 && (
          <section>
            {customersCollaborators.map(collaborator => (
              <Collaborator
                key={collaborator.id}
                collaborator={collaborator}
                onChange={handleChangeCollaborator}
                userWorkflow={userWorkflow}
                isAllowedToChange={myCollaborator?.canInviteCollaborators ?? false}
              />
            ))}
          </section>
        )}
        {otherCollaborators.map(collaborator => (
          <Collaborator
            key={collaborator.id}
            collaborator={collaborator}
            onChange={handleChangeCollaborator}
            userWorkflow={userWorkflow}
            isAllowedToChange={myCollaborator?.canInviteCollaborators ?? false}
          />
        ))}
      </div>
    </Modal>
  );
};

export default AddUserWorkflowCollaboratorModal;
